import webApi from "./api"

export class SurveyService {
    saveExitSurveyResponse(data) {
        return webApi.post('dropoff-survey/save-response', data)
    }
}

const surveyService = new SurveyService()

export default surveyService